export default function useDataOnSubmit(props, data) {
  return function onSubmit() {
    props?.closePopover()
  }
}
